import React from 'react';
import { createPortal } from 'react-dom';

type Props = {
  children: React.ReactNode;
};

export default function DropdownPortal({ children }: Props) {
  if (typeof document === 'undefined') return null;

  return createPortal(children, document.body);
}